import { getShortcutsTypeaheadQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/tasksKeys.js';
import { getShortcutsTypeahead } from '#pplx/frontend/apps/ask/queries/shortcut-queries/getShortcutsTypeahead.js';
import { useIsUserLoggedIn } from '#pplx/frontend/auth/userHooks.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
export const useShortcutsTypeaheadQuery = ({ reason, ...options }) => {
    const isUserLoggedIn = useIsUserLoggedIn();
    return useQuery({
        queryKey: getShortcutsTypeaheadQueryKey(),
        queryFn: async () => {
            const { tasks } = await getShortcutsTypeahead({ reason });
            return tasks;
        },
        ...options,
        enabled: isUserLoggedIn && (options.enabled ?? true),
    });
};
//# sourceMappingURL=useShortcutsTypeaheadQuery.js.map